var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_87269",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_87269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8008 11.9998L14.7008 15.8998C14.8841 16.0831 14.9758 16.3165 14.9758 16.5998C14.9758 16.8831 14.8841 17.1165 14.7008 17.2998C14.5174 17.4831 14.2841 17.5748 14.0008 17.5748C13.7174 17.5748 13.4841 17.4831 13.3008 17.2998L8.70078 12.6998C8.60078 12.5998 8.52995 12.4915 8.48828 12.3748C8.44661 12.2581 8.42578 12.1331 8.42578 11.9998C8.42578 11.8665 8.44661 11.7415 8.48828 11.6248C8.52995 11.5081 8.60078 11.3998 8.70078 11.2998L13.3008 6.6998C13.4841 6.51647 13.7174 6.4248 14.0008 6.4248C14.2841 6.4248 14.5174 6.51647 14.7008 6.6998C14.8841 6.88314 14.9758 7.11647 14.9758 7.3998C14.9758 7.68314 14.8841 7.91647 14.7008 8.0998L10.8008 11.9998Z",
    fill: "#0C0C0E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.1c12914e45894f1fd0558cdfb6f2e27e.svg";
export { ForwardRef as ReactComponent };